import React from 'react';

interface MinusIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const MinusIcon: React.FC<MinusIconProps> = ({ 
  width = 14, 
  height = 2, 
  color = '#161616',
  className,
  style 
}) => {
  // width와 height를 CSS 스타일로 처리
  const svgStyle: React.CSSProperties = {
    width: typeof width === 'string' ? width : `${width}px`,
    height: typeof height === 'string' ? height : `${height}px`,
    ...style
  };

  // viewBox를 기준으로 한 기본 크기 (픽셀)
  const defaultWidth = typeof width === 'number' ? width : 14;
  const defaultHeight = typeof height === 'number' ? height : 2;

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={defaultWidth} 
      height={defaultHeight} 
      fill="none" 
      viewBox="0 0 14 2"
      className={className}
      style={svgStyle}
    >
      <path 
        d="M12.5996 0C12.931 0 13.1992 0.268239 13.1992 0.599609C13.1992 0.93098 12.931 1.19922 12.5996 1.19922H0.599609C0.268239 1.19922 0 0.93098 0 0.599609C0 0.268239 0.268239 0 0.599609 0H12.5996Z" 
        fill={color}
      />
    </svg>
  );
};

export default MinusIcon;


